import { EMPTY_VALUE } from "./display";

// Date utility functions for consistent formatting across the application

/**
 * Format a date to DD/MM/YYYY format
 * @param date - Date object or date string
 * @returns Formatted date string in DD/MM/YYYY format
 */
export const formatDate = (date: Date | string | null | undefined): string => {
  // Handle null, undefined, or empty values
  if (!date || date === null || date === undefined) {
    return EMPTY_VALUE;
  }
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // Check if the date is valid
  if (!dateObj || isNaN(dateObj.getTime())) {
    return 'Date invalide';
  }
  
  const day = dateObj.getDate().toString().padStart(2, '0');
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const year = dateObj.getFullYear();
  
  return `${day}/${month}/${year}`;
};

/**
 * Format a date to DD/MM/YYYY HH:MM format
 * @param date - Date object or date string
 * @returns Formatted date string in DD/MM/YYYY HH:MM format
 */
export const formatDateTime = (date: Date | string | null | undefined): string => {
  // Handle null, undefined, or empty values
  if (!date || date === null || date === undefined) {
    return EMPTY_VALUE;
  }
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // Check if the date is valid
  if (!dateObj || isNaN(dateObj.getTime())) {
    return 'Date invalide';
  }
  
  const day = dateObj.getDate().toString().padStart(2, '0');
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const year = dateObj.getFullYear();
  const hours = dateObj.getHours().toString().padStart(2, '0');
  const minutes = dateObj.getMinutes().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};
